import React, {useState} from 'react';

import NoResultsMessage from 'app/components/general/NoResultsMessage';
import {useFolders} from 'app/folders/api';
import {FolderItem} from 'app/folders/components/FolderItem';
import {SearchInputField} from 'app/general/widgets/SearchInputField';
import {gt} from 'app/utils/i18n';

import type {MenuItemsType} from 'app/general/widgets/ThreeDotsDropdownMenu';
import type {FolderSerializedType} from 'sweet-types';

type Props = {
  actionsGetter: (
    object: FolderSerializedType,
    afterAction?: () => Promise<any>
  ) => MenuItemsType;
  refreshPosition: () => unknown;
};

export const FolderSelection = ({actionsGetter, refreshPosition}: Props) => {
  const [search, setSearch] = useState<string>('');
  const folderParam =
    search != ''
      ? {
          search,
        }
      : {
          parent: '',
        };

  const folders = useFolders(folderParam).data?.results;

  return (
    <>
      <SearchInputField
        autoFocus
        value={search}
        onChange={(q) => setSearch(q)}
        placeholder={gt('Search')}
      />

      {folders == null ? (
        <p className="text-center py-3 px-3 mb-0">
          <i className="fa fa-circle-notch fa-spin mr-2" />
          {gt('Loading folders')}...
        </p>
      ) : (
        <div className="overflow-auto">
          {folders.length > 0 ? (
            <>
              {folders.map((item) => (
                <FolderItem
                  small={true}
                  folder={item}
                  key={item.url}
                  isParentDirty={false}
                  isHidingDocuments={true}
                  isHidingCreateDocument={true}
                  isHidingCreateFolder={false}
                  isCreateFolderPopup={true}
                  isHidingTeams={true}
                  actionsGetter={actionsGetter}
                  onToggle={(
                    isExpanded: boolean,
                    item: FolderSerializedType,
                    promise: Promise<any>
                  ) => {
                    promise.then(refreshPosition);
                  }}
                />
              ))}
            </>
          ) : (
            <NoResultsMessage
              onSidebar={false}
              onPopover={true}
              icon="fa-folder"
              head={gt('No folders found')}
              classNameOverwrite="my-4 text-center"
            />
          )}
        </div>
      )}
    </>
  );
};
